<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" :selection="selection" :row-style="rowStyleFun" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu" :before-reset-search="beforeResetSearch">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SendEmail.table.EmailTitle')" prop="mailTitle">
            <BjInput v-model="queryParams.mailTitle" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SendEmail.table.EmailTitle')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SendEmail.table.SendingTime')">
            <BjDateRangePicker v-model="dataTime" :placeholder="$t('SendEmail.table.SendingTime')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'emailType'">
                <el-tag>{{ $t(SendEmail_STATUS_ADMIN.bjGet(scope.row[col.prop])) }}</el-tag>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn" @click="onView(scope.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import DataForm from "./components/DataForm.vue"
import { SendEmail_STATUS_ADMIN  } from '@/utils/constants';
import { userApi } from '@/api';
export default {
   name: 'BusinessUserDepartment',
   mixins: [pageMiXin],
   components: {
      DataForm,
   },
   data() {
      return {
         queryApi: userApi.MassconfigurationList,
         SendEmail_STATUS_ADMIN ,
         // 查询参数
         queryParams: {
            sendingEmail: null,
            startSendingTime: '',
            endSendingTime: ''
         },
         dataTime: [],
         labelList: [
            { label: this.$t('SendEmail.table.EmailTitle'), prop: 'mailTitle', isCheck: true, disabled: false },
            { label: this.$t('SendEmail.table.SendingTime'), prop: 'sendingTime', isCheck: true, disabled: false, },
            // { label: this.$t('SendEmail.table.SendEmail'), prop: 'sendingEmail', isCheck: true, disabled: false, },
            { label: this.$t('SendEmail.table.SendEmail'), prop: 'emailType', isCheck: true, disabled: false, },
            { label: this.$t('SendEmail.table.NumberOfsuccessful'), prop: 'succeedQuantity', isCheck: true, disabled: false, },
            { label: this.$t('SendEmail.table.NameCustomer'), prop: 'loseName', isCheck: true, disabled: false, },
            { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
         ],
         addDialogVisible: false,
         title: '',
         form: { name: null, code: null },
         rules: {
            name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            code: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
         },
      };
   },
   watch: {
      dataTime(v) {
         this.queryParams.startSendingTime = (v || [])[0];
         this.queryParams.endSendingTime = (v || [])[1];
      }
   },
   methods: {
      onView(item){
         this.$refs.DataForm.show(item);
      },
      onAdd(){
         this.$refs.DataForm.show();
      },
      beforeResetSearch() {
         this.dataTime = [];
         this.queryParams.creationDateBegin = null;
         return new Promise(resolve => {
            resolve();
         });
      },
      //   新增
      handleOpen(val) {
         if (!val) {
            this.title = this.$t('addText');
            this.form.id = null;
            this.form.name = null;
            this.form.code = null;
         } else {
            this.title = this.$t('editText');
            this.form.id = val.id;
            this.form.name = val.name;
            this.form.code = val.code;
         }
         this.addDialogVisible = true;
         this.$nextTick(() => {
            this.$refs.form.clearValidate();
         });
      },
      submitForm(formName) {
         this.$refs[formName].validate(valid => {
            const data = {
               _innerMap: {},
               code: this.form.code,
               id: this.form.id,
               name: this.form.name,
            };
            if (valid) {
               if (this.form.id) {
                  // 修改
                  userApi.modifyDepartmentPageList(data).then(res => {
                     if (res.id || res._token || res.content || Array.isArray(res) || res.failed == false) {
                        this.$message.success(this.$t('toast.operationSuccessText'));
                        this.addDialogVisible = false;
                        this.reFresh();
                     }
                  })
               } else {
                  // 新增
                  userApi.addDepartmentPageList(data).then(res => {
                     if (res.id || res._token || res.content || Array.isArray(res) || res.failed == false) {
                        this.$message.success(this.$t('toast.operationSuccessText'));
                        this.addDialogVisible = false;
                        this.reFresh();
                     }
                  })
               }
            }
         });
      },
      handleClose() {
         this.addDialogVisible = false;
      },
   },
};
</script>

<style scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>